import { customAxios, PROFORMA_URL, IDUSUARIO } from '../constants';
import { FETCH_REPORTE_FDV,FETCH_REPORTE_EXCEL_FDV } from './types';
import { PAG_1, CANT_X_PAG } from '../actions';
import { evalAction, serverError } from '../utils/actionError';

export function fetchReporteFichaVenta(proforma = 'x') {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
    params: {
      nroProforma: proforma,
    },
  };

  const request = customAxios.get(`${PROFORMA_URL}/ficha-venta/exportar/pdf/resumen`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_REPORTE_FDV,
    payload: request,
  };
}

export function fetchReporteConsultaFichaVenta(
    codEstado = '[C,V,E,I]',
    nropag = PAG_1,
    cantidadxpag = CANT_X_PAG,
    opcNum = '',
    numero = '',
    tipoFecha = 'fcreacion',
    fecha1 = '',
    fecha2 = '',
    codAreaVenta = '',
    codFamilia = '',
    codFilial = '',
    codCia = '',
    codVendedor = '',
    codCliente = '',
    codZona = '',
    tipo = '',
    codMoneda = '',
    codBaumauster = '',
    codTipoPago = '',
    codMonedaCredito = '',
    codClausCompra = '',
    codConfig = '',
    codAdquisicion = '') {
    let fechaInicio = '';
    let fechaFin = '';
    let fechaInicioCierre = '';
    let fechaFinCierre = '';
    if (tipoFecha === 'fcreacion') {
        fechaInicio = fecha1 ? fecha1.format('DD/MM/YYYY') : '';
        fechaFin = fecha2 ? fecha2.format('DD/MM/YYYY') : '';
    } else if (tipoFecha === 'fcierre') {
        fechaInicioCierre = fecha1 ? fecha1.format('DD/MM/YYYY') : '';
        fechaFinCierre = fecha2 ? fecha2.format('DD/MM/YYYY') : '';
    }

    const config = {
        params: {
            codCia: codCia.length ? `[${codCia}]` : null,
            codAreaVenta: codAreaVenta.length ? `[${codAreaVenta}]` : null,
            codEstado: codEstado.length ? codEstado : null,
            numFichaVenta: opcNum === 'nfdv' ? numero : null,
            numProforma: opcNum === 'nproforma' ? numero : null,
            numPedido: opcNum === 'npedido' ? numero : null,
            fechaInicio,
            fechaFin,
            fechaInicioCierre,
            fechaFinCierre,
            codFamilia: codFamilia.length ? `[${codFamilia}]` : null,
            codFilial: codFilial.length ? `[${codFilial}]` : null,
            codVendedor: codVendedor.length ? codVendedor : null,
            codCliente: codCliente.length ? codCliente : null,
            codZona: codZona.length ? `[${codZona}]` : null,
            tipo: tipo.length ? `[${tipo}]` : null,
            codMoneda: codMoneda.length ? `[${codMoneda}]` : null,
            codBaumauster: codBaumauster.length ? codBaumauster : null,
            codTipoPago: codTipoPago.length ? `[${codTipoPago}]` : null,
            codMonedaCredito: codMonedaCredito.length ? `[${codMonedaCredito}]` : null,
            codClausCompra: codClausCompra.length ? codClausCompra : null,
            codConfig: codConfig.length ? codConfig : null,
            codAdquisicion: codAdquisicion.length ? `[${codAdquisicion}]` : null,
        },
        headers: {
            indpaginado: 'N',
            idUsuario: IDUSUARIO,
            nropag,
            cantidadxpag,
        },
    };

  const request = customAxios.get(`${PROFORMA_URL}/ficha-venta/exportar/excel/resumen`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_REPORTE_EXCEL_FDV,
    payload: request,
  };
}

/*Inicio Req. 92349 ebarboza 18 06 2021 */
export function fetchReporteConsultaFichaVentaBonos(
  codEstado = '[C,V,E,I]',
  nropag = PAG_1,
  cantidadxpag = CANT_X_PAG,
  opcNum = '',
  numero = '',
  tipoFecha = 'fcreacion',
  fecha1 = '',
  fecha2 = '',
  codAreaVenta = '',
  codFamilia = '',
  codFilial = '',
  codCia = '',
  codVendedor = '',
  codCliente = '',
  codZona = '',
  tipo = '',
  codMoneda = '',
  codBaumauster = '',
  codTipoPago = '',
  codMonedaCredito = '',
  codClausCompra = '',
  codConfig = '',
  codAdquisicion = '') {
  let fechaInicio = '';
  let fechaFin = '';
  let fechaInicioCierre = '';
  let fechaFinCierre = '';
  if (tipoFecha === 'fcreacion') {
      fechaInicio = fecha1 ? fecha1.format('DD/MM/YYYY') : '';
      fechaFin = fecha2 ? fecha2.format('DD/MM/YYYY') : '';
  } else if (tipoFecha === 'fcierre') {
      fechaInicioCierre = fecha1 ? fecha1.format('DD/MM/YYYY') : '';
      fechaFinCierre = fecha2 ? fecha2.format('DD/MM/YYYY') : '';
  }

  const config = {
      params: {
          codCia: codCia.length ? `[${codCia}]` : null,
          codAreaVenta: codAreaVenta.length ? `[${codAreaVenta}]` : null,
          codEstado: codEstado.length ? codEstado : null,
          numFichaVenta: opcNum === 'nfdv' ? numero : null,
          numProforma: opcNum === 'nproforma' ? numero : null,
          numPedido: opcNum === 'npedido' ? numero : null,
          fechaInicio,
          fechaFin,
          fechaInicioCierre,
          fechaFinCierre,
          codFamilia: codFamilia.length ? `[${codFamilia}]` : null,
          codFilial: codFilial.length ? `[${codFilial}]` : null,
          codVendedor: codVendedor.length ? codVendedor : null,
          codCliente: codCliente.length ? codCliente : null,
          codZona: codZona.length ? `[${codZona}]` : null,
          tipo: tipo.length ? `[${tipo}]` : null,
          codMoneda: codMoneda.length ? `[${codMoneda}]` : null,
          codBaumauster: codBaumauster.length ? codBaumauster : null,
          codTipoPago: codTipoPago.length ? `[${codTipoPago}]` : null,
          codMonedaCredito: codMonedaCredito.length ? `[${codMonedaCredito}]` : null,
          codClausCompra: codClausCompra.length ? codClausCompra : null,
          codConfig: codConfig.length ? codConfig : null,
          codAdquisicion: codAdquisicion.length ? `[${codAdquisicion}]` : null,
      },
      headers: {
          indpaginado: 'N',
          idUsuario: IDUSUARIO,
          nropag,
          cantidadxpag:CANT_X_PAG,
      },
  };

const request = customAxios.get(`${PROFORMA_URL}/ficha-venta/exportar/excel/bonos/resumen`, config)
.then(({ data }) => evalAction(data, 'listar'))
.catch(error => serverError(error, 'listar'))

return {
  type: FETCH_REPORTE_EXCEL_FDV,
  payload: request,
};
}
/*Fin Req. 92349 ebarboza 18 06 2021 */



// WEBPACK FOOTER //
// ./src/actions/Reporte.js